export { TABLE_EXTRACT_PT_BR } from "./table-extract-pt-br";
export { TABLE_EXTRACT_EN_US } from "./table-extract-en-us";
export { TABLE_EXTRACT_ES_MX } from "./table-extract-es-mx";
export { TABLE_EXTRACT_FR_FR } from "./table-extract-fr-fr";

export type { TableExtractPtBr } from "./table-extract-pt-br";
